import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import { WaButton, scrollToId, EASE } from "@/components/site/ui";

const LINES = [
  <>Kujtimet,</>,
  <>të <em className="text-gold-grad font-display italic">gdhendura</em></>,
  <>në gur.</>,
];

export const PortreteHero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [0, -100]);

  return (
    <section ref={ref} className="relative min-h-[100svh] bg-[#0B0B0C] overflow-hidden" data-testid="portrete-hero">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 pt-32 sm:pt-40 pb-20 grid lg:grid-cols-12 gap-12 items-center min-h-[100svh]">
        <div className="lg:col-span-7">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.2 }} className="font-mono-x text-xs tracking-[0.35em] uppercase text-[#C9A55C] mb-8 flex items-center gap-3">
            <span className="h-px w-10 bg-[#C9A55C]" /> Gdhendje me lazer · Portrete në gur
          </motion.p>
          <h1 className="font-display font-light text-[#F3EEE4] text-[3.1rem] leading-[0.98] sm:text-7xl lg:text-[6.2rem] xl:text-[7rem] tracking-[-0.02em]" data-testid="portrete-title">
            {LINES.map((l, i) => (
              <span key={i} className="block overflow-hidden pb-[0.08em]">
                <motion.span className="block" initial={{ y: "110%", rotate: 3 }} animate={{ y: "0%", rotate: 0 }} transition={{ duration: 1.3, delay: 0.3 + i * 0.14, ease: EASE }}>
                  {l}
                </motion.span>
              </span>
            ))}
          </h1>
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 1, ease: EASE }}>
            <p className="mt-10 max-w-xl text-base md:text-lg text-[#CFC8BA] leading-relaxed">
              Portrete me lazer në mermer dhe granit: nga një fotografi, një imazh i detajuar që zgjat brez pas brezi. Për përkujtimore, dhurata dhe dekor.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <WaButton testId="portrete-hero-whatsapp" topic="një portret me lazer në gur" label="Dërgoni foton në WhatsApp" />
              <button onClick={() => scrollToId("si-funksionon")} data-testid="portrete-how-cta" className="btn-ghost group inline-flex items-center gap-2 rounded-full px-7 py-4 text-sm tracking-wide text-[#F3EEE4]">
                Si funksionon <ArrowDownRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-45" />
              </button>
            </div>
          </motion.div>
        </div>
        <motion.div style={{ y: imgY }} className="lg:col-span-5">
          <motion.div initial={{ clipPath: "inset(100% 0% 0% 0%)" }} animate={{ clipPath: "inset(0% 0% 0% 0%)" }} transition={{ duration: 1.6, delay: 0.5, ease: EASE }} className="relative aspect-[3/4] max-w-[440px] mx-auto lg:ml-auto overflow-hidden laser-frame slab-shadow">
            <img src="/img/laser-portrait.jpg" alt="Portret i gdhendur me lazer në granit të zi" className="w-full h-full object-cover" />
            <span className="laser-line" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
